// extracted by mini-css-extract-plugin
module.exports = {"container":"Sg","timeTop":"Tg","timeCountdown":"Ug","cta":"Vg","disabled":"Wg","product":"Xg"};